class Galleries {
  constructor(elems) {
    this.elems = elems;
    this.galleries = this.elems.map((index, gallery) => this.initGallery(gallery))
  }

  initGallery(gallery) {
    let $this   = $(gallery);
    let $center = $this.siblings('.center'); 
    $(gallery).slick({
      appendDots: $center.find('.dots-parent')
    });

    $center.find('.slider-next-arrow').click(() => {
      $this.slick('slickNext');
    });

    $center.find('.slider-prev-arrow').click(() => {
      $this.slick('slickPrev');
    });

    if ($this.hasClass('focus-mode')) {
      let $focusSlider = $this;
      $this.find('.slick-slide').on('click', function(e) {
        e.stopPropagation();
        let $this = $(this);
        let index = $(this).data().slickIndex;

        if ($focusSlider.slick('slickCurrentSlide') !== index) {
          $focusSlider.slick('slickCurrentSlide') > index ? $focusSlider.slick('slickPrev'): $focusSlider.slick('slickNext');
        }
      })
    }
  }
}

export default Galleries;



// WEBPACK FOOTER //
// ./app/javascript/articles/galleries/index.js